import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'mtn-key-value',
  templateUrl: './key-value.component.html',
  styleUrls: ['./key-value.component.scss']
})
export class KeyValueComponent  {

  @Input()
  key: string;
  @Input()
  keyWidthPercent: number = 40;
  @Input()
  alignment: string = 'start start';
  @Input()
  whatIsThisText: string;

  constructor() {
  }


}
